import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import Link from '@material-ui/core/Link';

import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { makeSelectUsers, makeSelectClients } from '../../selectors/clients';

const useStyles = makeStyles(theme => ({
  wrapper: {
    paddingTop: theme.spacing(3),
  },
  grid: {
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(2.5),
  },
  sectionTitle: {
    borderBottom: '2px solid #DFDFDF',
    padding: theme.spacing(3),
  },
}));

const headCells = [
  { id: 'id', numeric: false, disablePadding: true, label: 'ID' },
  { id: 'email', numeric: false, disablePadding: true, label: 'Email' },
  { id: 'created', numeric: false, disablePadding: true, label: 'Created' },
];

function ClientUsersTable(props) {
  const { selectedClient, onRowClick } = props;

  let thisUsers = [];
  if ('users' in selectedClient) {
    thisUsers = selectedClient.users;
  }

  const classes = useStyles();
  return (
    <Grid className={classes.grid} maxwidth="lg">
      <Paper>
        <Typography className={classes.sectionTitle} variant="h5" component="h3">
          Users
        </Typography>
        <Container className={classes.wrapper} maxwidth="lg">
          <Table>
            <TableHead>
              <TableRow>
                {headCells.map(headCell => (
                  <TableCell
                    key={headCell.id}
                    align={headCell.numeric ? 'right' : 'left'}
                    padding={headCell.disablePadding ? 'none' : 'default'}
                  >
                    {headCell.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {thisUsers.map(row => (
                <TableRow key={row.id} hover>
                  <TableCell component="th" scope="row">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <Link
                      className={classes.link}
                      onClick={() => {
                        onRowClick(row.id);
                      }}
                    >
                      {row.id}
                    </Link>
                  </TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>{row.createdAt}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Container>
      </Paper>
    </Grid>
  );
}

ClientUsersTable.defaultProps = {
  selectedClient: {},
  onRowClick: () => {},
};

ClientUsersTable.propTypes = {
  selectedClient: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    billingAddressLine1: PropTypes.string,
    billingAddressLine2: PropTypes.string,
    billingAddressZip: PropTypes.string,
    billingAddressState: PropTypes.string,
    billingAddressCity: PropTypes.string,
    users: PropTypes.arrayOf(
      PropTypes.shape({
        createdAt: PropTypes.string,
        email: PropTypes.string,
        id: PropTypes.number,
      })
    ),
  }),
  onRowClick: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  clients: makeSelectClients(),
  users: makeSelectUsers(),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ClientUsersTable);
